// extracted by mini-css-extract-plugin
module.exports = {"root":"RichTextInput_root__3JKds"};